<nz-form-item class="ui-form-password">
  @if (false) {
  <nz-form-label [nzRequired]="isRequired">{{ label | localization }}</nz-form-label>
  }
  <nz-form-control [nzValidateStatus]="control ?? 'success'" [nzErrorTip]="errorTip | localization">
    <nz-input-group [nzSuffix]="suffixTemplate">
      <input
        [type]="passwordVisible ? 'text' : 'password'"
        nz-input
        [placeholder]="placeholder | localization"
        [value]="value"
        (blur)="onBlur()"
        (input)="onInput($event)"
        (keydown.enter)="onEnterPressed()"
        [disabled]="disabled"
      />
    </nz-input-group>
  </nz-form-control>
</nz-form-item>

<ng-template #suffixTemplate>
  <span
    *ngIf="!disabled"
    nz-icon
    class="ant-input-password-icon"
    [nzType]="passwordVisible ? 'eye-invisible' : 'eye'"
    (click)="passwordVisible = !passwordVisible"
    aria-hidden="true"
  ></span>
</ng-template>
